// Visible portfolio menus follow the supplied production menu list.
const menuNames = Object.fromEntries([
  ['LV000000', '대시보드'],
  ['LV060000', '파트너 관리'], ['LV060100', '파트너 리스트'], ['LV060600', '파트너 생성'],
  ['LV010000', '회원 관리'], ['LV010100', '회원 생성'], ['LV010200', '회원 리스트'],
  ['LV010600', '회원 리스트(파트너별)'], ['LV010300', '회원 가입승인'],
  ['LV010500', '캐시이동내역'], ['LV010700', '포인트 관리'], ['LV010800', '사용자 추적'],
  ['LV010900', '접속중인 회원'], ['LV011100', '멀티아이피 내역'],
  ['LV020000', '베팅 내역'], ['LV020700', '통합베팅내역'], ['LV020100', '카지노 내역'], ['LV020200', '슬롯 내역'],
  ['LV070000', '입출금 관리'], ['LV070100', '입금신청내역'], ['LV070200', '입금내역조회'],
  ['LV070300', '출금신청내역'], ['LV070400', '출금내역조회'], ['LV070500', '관리자 지급/회수'],
  ['LV070600', '캐시변동내역'], ['LV070700', '쿠폰관리'],
  ['LV080000', '정산 관리'], ['LV080800', '파트너정산내역'], ['LV080600', '파트너정산내역II'],
  ['LV080900', '회원정산내역'], ['LV080300', '게임별 리포트'], ['LV080400', '일자별 리포트'],
  ['LV120000', '게임관리'], ['LV120100', '카지노 설정'], ['LV120200', '슬롯 설정'],
  ['LV100000', '고객센터 관리'], ['LV100100', '쪽지 관리'], ['LV100300', '1:1문의 관리'],
  ['LV100400', '공지사항 관리'], ['LV100500', '자주묻는질문 관리'],
  ['LV090000', '설정'], ['LV090301', '이벤트 보너스 설정'], ['LV090304', '등급별 베팅 설정'],
  ['LV090401', '팝업 설정'], ['LV090404', '옵션 설정'],
  ['LV110000', '관리자 환경설정'], ['LV110100', '관리자 리스트'],
  ['LV110200', '관리자접속 IP관리'], ['LV110400', '관리자 로그']
])

module.exports = { menuNames }
